import styled from 'styled-components'
import { respondToMin } from 'shared/theme'
import { UI } from 'components/UI/UI.styled'

const Wrap = styled(UI.Container)`
  margin: 20px auto;
  padding: 0px;
  position: relative;
  z-index: 0;
  
  ${respondToMin.tablet`
    padding: 0px 40px;
    margin: 30px auto;
  `}
  
  @media (min-width: 1200px) {
    margin: 40px auto;
  }
  
  @media (min-width: 1400px) {
    margin: 50px auto;
  }
`

const BannerContainer = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  
  @media (max-width: 768px) {
    border-radius: 4px;
  }
`

const BannerImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 0.95;
  }
`

export const Styled = {
  Wrap,
  BannerContainer,
  BannerImage,
}
